import { Email } from "./Icons/Email";
import Instagram from "./Icons/Instagram";
import { Phone } from "./Icons/Phone";
import LandpageBg from "./Assets/landpage bg.jpg";
import Family from "./Assets/Family.png";
import Divorce from "./Assets/Divorce.png";
import FamilyRights from "./Assets/FamilyRights.png";
import Heir from "./Assets/Heir.png";
import Inventory from "./Assets/Inventory.png";
import Mediation from "./Assets/Mediation.png";
import Partition from "./Assets/Partition.png";
import RegisterHouse from "./Assets/RegisterHouse.png";
import Shop from "./Assets/Shop.png";
import Carreira0 from "./Assets//Juliana-Esteves-Advogada.jpg";
import Carreira2 from "./Assets/Juliana-Esteves-Advogada-3.jpg";
import Carreira3 from "./Assets/Juliana-Esteves-Advogada-4.jpg";
import LogoNav from "./Assets/Juliana-Logo-Transparent.svg";
import LogoFooterStroke from "./Assets/Logo-Footer.svg";

export const nav = [
  {
    id: "/",
    name: "Início",
    link: "/",
  },
  {
    id: "/areasdeatuacao",
    name: "Áreas de atuação e Parcerias",
    link: "/areasdeatuacao",
  },
  {
    id: "/carreira",
    name: "Carreira",
    link: "/carreira",
  },
  {
    id: "/contato",
    name: "Contato",
    link: "/contato",
  },
];

export const contacts = [
  {
    image: <Instagram />,
    link: "https://www.instagram.com/dra.julianaesteves/",
    alt: "Juliana Esteves Advocacia Intagram",
  },
  {
    image: <Email />,
    link: "mailto:julianaesteves@adv.oabrj.org.br",
    alt: "Juliana Esteves Advocacia Email",
  },
];

export const phoneNumber = [
  {
    id: "/inicio",
    image: <Phone />,
    link: "https://wa.me/5521986065478?text=Olá, gostaria de receber orientação jurídica.",
    number: "(21) 98606-5478",
    alt: "Juliana Esteves Advocacia Whatsapp",
  },
];

export const homeData = [
  {
    image: LandpageBg,
    alt: "Landpage background - Dra. Juliana Antunes Advocacia",
    text: "Minha missão é oferecer serviços jurídicos de excelência, pautados pela integridade, pelo comprometimento e por uma atuação verdadeiramente humana. Acredito que cada caso carrega uma história única e é com empatia, técnica e firmeza que busco as melhores soluções para meus clientes. Trabalho com dedicação absoluta para garantir resultados justos e eficazes, sempre guiada pelos mais altos padrões éticos e pela responsabilidade que a advocacia exige.",
    author: "Dra. Juliana Esteves - Advogada",
  },
];

export const AreasDeAtuacao = [
  {
    id: "/areasdeatuacao",
    name: "Áreas de atuação",
    text: "No Escritório de Advocacia Juliana Esteves, temos um compromisso com a excelência na prestação de serviços jurídicos nas áreas de Direito Civil, Direito de Família, Direito das Sucessões, Direito do Consumidor e Direito ambiental. \n\nEssas especialidades envolvem questões sensíveis e de grande relevância para o patrimônio, a vida dos nossos clientes e o meio ambiente em que eles vivem. Atuamos com responsabilidade, empatia e profundo conhecimento técnico para oferecer soluções jurídicas eficazes e humanizadas.",
  },
];

export const CarreiraTitle = [
  {
    id: "/carreira",
    name: "Carreira",
    text: "Com dedicação, ética e foco em resultados, Dra. Juliana Esteves vem construindo uma trajetória sólida e respeitada na advocacia. Seu compromisso vai além da atuação jurídica: ela promove justiça, equidade e dá voz a quem não é ouvido. Mantém seus clientes informados em todas as etapas relevantes do processo, cultivando uma relação de confiança e profissionalismo.\n\nMais do que exercer a advocacia, sua missão é lutar pelos direitos de quem não tem voz, com firmeza, sensibilidade e busca incessante pela verdade. O respeito e a confiança de seus clientes refletem seu principal alicerce: o comprometimento genuíno com cada causa e com as pessoas que nela confiam.\n\nDesde o início de sua carreira, ela se destacou pelo seu compromisso com a ética, a integridade e a excelência no exercício da advocacia. Sua abordagem centrada no cliente, combinada com sua expertise jurídica e sua paixão pela justiça, faz dela uma escolha excepcional para aqueles que buscam representação legal de qualidade e comprometimento genuíno.",
  },
];

export const ContatoTitle = [
  {
    id: "/contato",
    name: "Atendimento e Contato",
    text: "A primeira fase é o atendimento, que é gratuito e breve, momento em que eu entendo qual a demanda do cliente e faço uma breve avaliação a respeito. O atendimento pode ser feito diretamente pelo WhatsApp em demandas mais sucintas ou então por vídeo-chamada. Mesmo para atendimentos iniciais tento marcar um horário. \nNa segunda fase, eu avalio se há necessidade de encaminhar o cliente para uma consultoria ou já encaminho a proposta de prestação de serviços. \nSe o cliente quiser receber um parecer jurídico verbal ou aprofundar maiores dúvidas antes de fechar o contrato, marcamos a consultoria, que é dividida em duas partes: \n\n1) O cliente me envia os documentos, provas, número de processo, ou qualquer outro documento pertinente, e eu estudo e analiso o seu caso. \n2) Fazemos uma vídeo-chamada ou então uma consultoria presencial, e nesse momento eu dou todo o amparo técnico e jurídico ao cliente, explicando a demanda, tirando suas dúvidas, e esclarecendo sobre as estratégias que eu adotarei e as possibilidades de êxito de uma ação naquele caso concreto, sempre com total transparência em respeito ao tempo e aos recursos do cliente. \n\nApós a consultoria eu encaminho, em até 24 horas, a proposta da prestação dos meus serviços, frisando pontos importantes da conversa que tivemos e explicando como funcionará a minha atuação no caso dele. \nMeu objetivo é ser transparente na minha atuação e trazer segurança e conforto ao cliente. \n\nEntre em contato comigo por E-mail ou WhatsApp:",
  },
];

export const ClientFeedbackTitle = [
  {
    id: "/comments",
    name: "Palavras de quem confia no meu trabalho",
    text: "Veja o que meus clientes dizem sobre meu trabalho:",
  },
];

export const ContatoData = [
  {
    id: 0,
    icon: <Email color="rgb(198, 166, 108)" />,
    text: "julianaesteves@adv.oabrj.org.br",
    link: "mailto:julianaesteves@adv.oabrj.org.br",
    name: "E-mail",
  },
  {
    id: 1,
    icon: <Phone color="rgb(198, 166, 108)" />,
    text: "(21) 98606 5478",
    link: "https://wa.me/5521986065478?text=Olá, gostaria de receber orientação jurídica.",
    name: "Whatsapp",
  },
];

export const imageSlider = [
  {
    id: 1,
    image: Carreira0,
    alt: "Juliana Esteves Advocacia",
  },
  {
    id: 2,
    image: Carreira2,
    alt: "Juliana Esteves Advocacia",
  },
  {
    id: 3,
    image: Carreira3,
    alt: "Juliana Esteves Advocacia",
  },
];

export const tabContentData = [
  {
    parentId: 1,
    icon: FamilyRights,
    tabName: "Direito Civil",
    text: "Assessoramos em demandas contratuais, responsabilidade civil, obrigações e demais relações jurídicas entre particulares:",
    name: [
      {
        id: 1,
        icon: Divorce,
        type: "Ações de cobrança e indenizatórias (danos morais e materiais)",
        description: "",
      },
      {
        id: 1,
        icon: Divorce,
        type: "Rescisão contratual com devolução de valores",
        description: "",
      },
      {
        id: 1,
        icon: Divorce,
        type: "Responsabilidade civil por falhas em serviços, produtos ou prejuízos diversos",
        description: "",
      },
      {
        id: 1,
        icon: Divorce,
        type: "Revisão e anulação de contratos",
        description: "",
      },
      {
        id: 1,
        icon: Inventory,
        type: "Obrigações de fazer e não fazer (cumprimento de contrato, entrega de bens etc.)",
        description: "",
      },
      {
        id: 1,
        icon: Heir,
        type: "Defesa do consumidor contra empresas e instituições financeiras",
        description: "",
      },
      {
        id: 1,
        icon: Partition,
        type: "Reparação por vícios em imóveis ou produtos",
        description: "",
      },
      {
        id: 1,
        icon: Mediation,
        type: "Tutelas de urgência para resguardar direitos",
        description: "",
      },
      {
        id: 1,
        icon: RegisterHouse,
        type: "Assessoria preventiva em contratos e negociações",
        description: "",
      },
    ],
  },
  {
    parentId: 2,
    icon: Shop,
    tabName: "Direito de Família",
    text: "Prestamos suporte em processos de divórcio, guarda, pensão alimentícia, união estável e demais questões que envolvem vínculos afetivos e familiares:",
    name: [
      {
        id: 2,
        icon: Family,
        type: "Divórcio",
        description:
          "Atuação completa na dissolução do casamento, com foco em acordos consensuais que preservem o bem-estar das partes e dos filhos.",
      },
      {
        id: 2,
        icon: Family,
        type: "União Estável",
        description:
          "Reconhecimento ou dissolução da união estável, com orientação sobre partilha de bens, direitos e deveres dos companheiros.",
      },
      {
        id: 2,
        icon: Family,
        type: "Guarda, Visitas e Convivência",
        description:
          "Definição de guarda, regulamentação de visitas e convivência familiar, sempre priorizando o melhor interesse da criança.",
      },
      {
        id: 2,
        icon: Family,
        type: "Pensão Alimentícia",
        description:
          "Propositura e defesa em ações de fixação, revisão, exoneração e cobrança de alimentos, garantindo os direitos dos dependentes.",
      },
      {
        id: 2,
        icon: Family,
        type: "Investigação e Reconhecimento de Paternidade",
        description:
          "Ações judiciais e extrajudiciais para assegurar o vínculo legal entre pais e filhos, com todos os efeitos jurídicos decorrentes.",
      },
      {
        id: 2,
        icon: Family,
        type: "Regime de Bens e Pactos Antenupciais",
        description:
          "Consultoria para escolha ou alteração do regime de bens, elaboração de pactos antenupciais e contratos de convivência.",
      },
      {
        id: 2,
        icon: Family,
        type: "Interdição e Curatela",
        description:
          "Procedimentos para proteção de pessoas com incapacidade civil, com nomeação de curador e regularização de responsabilidades legais.",
      },
      {
        id: 2,
        icon: Family,
        type: "Alvarás Judiciais",
        description:
          "ARequerimento de alvarás para movimentação de valores, venda de bens ou autorização de atos em nome de menores ou incapazes.",
      },
      {
        id: 2,
        icon: Family,
        type: "Soluções Extrajudiciais",
        description:
          "Mediação e orientação em conflitos familiares, buscando soluções consensuais que preservem os vínculos afetivos e evitem litígios.",
      },
    ],
  },
  {
    parentId: 3,
    icon: Shop,
    tabName: "Direito das Sucessões",
    text: " Orientamos na elaboração de testamentos, inventários e partilhas, garantindo segurança jurídica na transmissão de bens.",
    name: [
      {
        id: 3,
        icon: Family,
        type: "Inventário",
        description:
          "Assessoria completa na abertura e condução de inventários judiciais ou extrajudiciais, garantindo a correta partilha dos bens e cumprimento das obrigações legais.",
      },
      {
        id: 3,
        icon: Family,
        type: "Testamentos",
        description:
          "Orientação na elaboração de testamentos seguros e personalizados, respeitando a vontade do testador e os limites legais, com foco na prevenção de litígios futuros.",
      },
      {
        id: 3,
        icon: Family,
        type: "Planejamento Sucessório",
        description:
          "Estratégias jurídicas para organizar a transmissão de bens em vida, reduzindo encargos tributários e evitando conflitos entre herdeiros.",
      },
      {
        id: 3,
        icon: Family,
        type: "Doações com Cláusulas Restritivas",
        description:
          "Consultoria na realização de doações com cláusulas de proteção patrimonial, como inalienabilidade, impenhorabilidade e reversão, preservando o interesse do doador.",
      },
      {
        id: 3,
        icon: Family,
        type: "Regularização de Herdeiros",
        description:
          "Atuação na formalização da situação jurídica de herdeiros, garantindo seus direitos e acesso aos bens deixados pelo falecido.",
      },
      {
        id: 3,
        icon: Family,
        type: "Renúncia ou Aceitação de Herança",
        description:
          "Esclarecimento sobre os efeitos legais da renúncia ou aceitação da herança, com análise estratégica para cada caso.",
      },
      {
        id: 3,
        icon: Family,
        type: "Exclusão de Herdeiros",
        description:
          "Propositura de ações judiciais para exclusão de herdeiros em hipóteses previstas em lei, como indignidade ou deserdação.",
      },
      {
        id: 3,
        icon: Family,
        type: "Usucapião de Bens Herdados",
        description:
          "Regularização da posse de bens herdados por meio de ação de usucapião, quando não há formalização da propriedade.",
      },
      {
        id: 3,
        icon: Family,
        type: "Mediação e Litígios Sucessórios",
        description:
          "Atuação em mediação e processos judiciais envolvendo disputas entre herdeiros ou interessados na sucessão, buscando soluções eficazes e pacificação familiar.",
      },
    ],
  },
  {
    parentId: 4,
    icon: Shop,
    tabName: "Direito do Consumidor",
    text: "Defendemos os direitos dos consumidores em situações de abusos, cláusulas contratuais lesivas, vícios de produtos e serviços, entre outros.",
    name: [
      {
        id: 4,
        icon: Family,
        type: "Cobrança indevida",
        description:
          "Defesa contra valores cobrados sem respaldo legal, com pedido de restituição em dobro.",
      },
      {
        id: 4,
        icon: Family,
        type: "Vício de produto ou serviço",
        description:
          "Ações por defeitos em produtos ou serviços prestados de forma inadequada ou incompleta.",
      },
      {
        id: 4,
        icon: Family,
        type: "Contratos abusivos",
        description:
          "Contestação de cláusulas que ferem os direitos do consumidor, com pedido de revisão ou cancelamento.",
      },
      {
        id: 4,
        icon: Family,
        type: "Negativação indevida",
        description:
          "Retirada do nome dos cadastros de inadimplentes em casos de dívida inexistente, quitada ou contestada.",
      },
      {
        id: 4,
        icon: Family,
        type: "Danos morais e materiais",
        description:
          "Indenizações por prejuízos causados por práticas abusivas, negligência ou descumprimento contratual.",
      },
      {
        id: 4,
        icon: Family,
        type: "Problemas com instituições financeiras",
        description:
          "Contestação de juros abusivos, tarifas indevidas, cobranças excessivas e contratos bancários.",
      },
      {
        id: 4,
        icon: Family,
        type: "Publicidade enganosa",
        description:
          "Atuação em casos de propaganda que induz o consumidor ao erro ou omite informações relevantes.",
      },
      {
        id: 4,
        icon: Family,
        type: "Problemas com companhias aéreas ",
        description:
          "Ações por cancelamento ou atraso de voos, extravio de bagagem, overbooking, reembolso não realizado e má prestação de serviço.",
      },
      {
        id: 4,
        icon: Family,
        type: "Mediação com fornecedores",
        description:
          "Soluções extrajudiciais para conflitos entre consumidor e empresa, com foco na conciliação e agilidade.",
      },
      {
        id: 4,
        icon: Family,
        type: "Falta de energia e queda de energia constantes",
        description: "",
      },
      {
        id: 4,
        icon: Family,
        type: "Interrupção de Serviços de Água ou Luz",
        description:
          "Protegemos seus interesses quando serviços essenciais são interrompidos indevidamente.",
      },
    ],
  },
  {
    parentId: 5,
    icon: Shop,
    tabName: "Direito Ambiental",
    text: "A atuação no âmbito do Direito Ambiental da Dra. Juliana Esteves alia rigor jurídico e conhecimento científico. Graduada em Direito e em Biologia, com especialização em Impactos Ambientais e experiência prática na área, a advogada oferece uma assessoria diferenciada, voltada à regularização, prevenção de passivos e fortalecimento da responsabilidade socioambiental de pessoas físicas, empresas e propriedades rurais. (Nessa área também possui alguns parceiros especialistas)",
    name: [
      {
        id: 5,
        icon: Family,
        type: "Licenciamento Ambiental",
        description:
          "Orientação técnica e jurídica na obtenção de Licença Prévia, de Instalação e de Operação, com análise documental e acompanhamento junto aos órgãos competentes.",
      },
      {
        id: 5,
        icon: Family,
        type: "Pareceres Jurídicos Ambientais",
        description:
          "Elaboração de pareceres técnicos e jurídicos, com base na legislação ambiental aplicável, para solução estratégica de casos específicos.",
      },
      {
        id: 5,
        icon: Family,
        type: "Defesas e Recursos Administrativos",
        description:
          "Atuação junto ao IBAMA, INEA e secretarias municipais em processos administrativos decorrentes de autos de infração, embargos ou imposição de multas.",
      },
      {
        id: 5,
        icon: Family,
        type: "Regularização de Imóveis Rurais e Áreas de Preservação Permanente (APPs)",
        description:
          "Consultoria para inscrição no Cadastro Ambiental Rural (CAR), definição de reserva legal, regularização de áreas protegidas e adequação a exigências ambientais.",
      },
      {
        id: 5,
        icon: Family,
        type: "Responsabilidade Ambiental Empresarial",
        description:
          "Análise preventiva de riscos e implementação de boas práticas jurídicas voltadas à mitigação de passivos ambientais e à conformidade regulatória.",
      },
    ],
  },
];

export const LogoNavbar = [
  {
    image: LogoNav,
    link: "/",
    alt: "Juliana Antunes Advocacia",
  },
];

export const LogoFooter = [
  {
    image: LogoFooterStroke,
    link: "/",
    alt: "Juliana Antunes Advocacia",
  },
];

export const ParceriasProfissionais = [
  {
    id: 1,
    name: "Parcerias Profissionais",
    text: "Nosso escritório está aberto a parcerias com advogados que atuem nas mesmas áreas jurídicas que trabalhamos, com foco em fortalecer a atuação conjunta e ampliar os resultados para os clientes.",
    titleArea: "Oferecemos parcerias nas seguintes áreas:",
    areas: [
      {
        id: 1,
        area: "Direito Civil",
      },
      {
        id: 1,
        area: "Direito de Família e Sucessões",
      },
      {
        id: 1,
        area: "Direito do Consumidor",
      },
      {
        id: 1,
        area: "Responsabilidade Civil",
      },
      {
        id: 1,
        area: "Ações Indenizatórias",
      },
    ],
    parcerias: [
      {
        id: 2,
        parceria: "Atuação conjunta em processos",
      },
      {
        id: 2,
        parceria: "Correspondência jurídica em Niterói e região",
      },
      {
        id: 2,
        parceria: "Cobertura de audiências e diligências",
      },
      {
        id: 2,
        parceria: "Consultoria técnica em casos específicos",
      },
      {
        id: 2,
        parceria: "Divisão de honorários conforme o Código de Ética da OAB",
      },
    ],
    text2:
      "Prezamos pela ética, transparência e profissionalismo em todas as colaborações. Se você é advogado e deseja atuar conosco em uma dessas áreas, entre em contato. Será um prazer construir juntos soluções jurídicas eficazes. \n\nFale conosco para saber mais.",
  },
];
